export { Cordova } from './cordova';
